import { cn } from '@/lib/utils';
import { useGetLogo } from '@/services/api/hooks/images';
import { usePartnerId } from '@/services/authentication/hooks/user';
import { FunctionComponent } from 'react';

interface MspLogoProps {
  id?: string;
  className?: string;
}

const MspLogo: FunctionComponent<MspLogoProps> = ({ id, className }) => {
  const roleId = usePartnerId();

  const mspId = id || roleId;

  if (!mspId) throw new Error('Missing partner id');

  const [logoUrl] = useGetLogo(mspId);

  return (
    <div
      className={cn('bg-contain bg-no-repeat bg-center', className)}
      style={{
        backgroundImage: `url(${logoUrl})`
      }}
    ></div>
  );
};

export default MspLogo;
